import { Filter, FilterTypes } from 'components/FilterDrawer/FilterDrawer.config'
import { ICompanyOverviewSummary } from 'containers/CompanyOverviewTablePage/types'
import { removeKeywordSuffix } from 'containers/VerticalPage/common/utils'
import columns from '../../UI/VerticalTable/columns'
import { COLUMNS_IDS } from 'UI/VerticalTable/utils'
import { ITableColumnsType } from 'uikit/tables/default'

export const PIE_LEGENDS_COLORS: Record<keyof ICompanyOverviewSummary, string[]> = {
  industries: ['#2157C5', '#FFCC00', '#90ED7D', '#E200E7', '#00C2FF'],
  employees: ['#FFB0B0', '#FF6161', '#FFDBBD', '#F7A35C', '#FFEFB8'],
  companies: ['#7CB5EC', '#1DBFBF', '#90ED7D', '#F7A35C', '#E200E7'],
}

export const filtersInitialState: Filter[] = [
  {
    type: FilterTypes.CHIPS,
    name: 'overviewDetails.industry',
    label: 'Industry',
    value: [],
  },
  {
    type: FilterTypes.CHIPS,
    name: 'entityDetails.location',
    label: 'Headquarters Location',
    value: [],
  },
  {
    type: FilterTypes.CHIPS,
    name: 'totals.jurisdictions',
    label: 'Jurisdictions',
    value: [],
  },
  {
    type: FilterTypes.CHIPS,
    name: 'totals.localDepartments',
    label: 'Local Departments',
    value: [],
  },
  {
    type: FilterTypes.BOOL,
    name: 'totals.structureChange',
    label: 'Structure Changed',
    activeFilterLabel: 'Structure Changed',
    value: [],
  },
]

export const structureChangeTooltip = {
  name: 'totals.structureChange',
  tooltipText:
    'This filter identifies companies that have experienced a significant reduction in their local workforce, specifically a decrease of at least 30% year-over-year, in any given year. The filter is applicable only if the reduction amounts to a minimum of 10 employees, helping you pinpoint substantial structural changes within companies.',
}

export const companyOverviewColumns: ITableColumnsType<any> = [
  { ...columns[COLUMNS_IDS.verifiedName], fixed: 'left' as const, minWidth: 150 },
  columns[COLUMNS_IDS.companyIndustry],
  columns[COLUMNS_IDS.companyFounded],
  columns[COLUMNS_IDS.companyLocations],
  columns[COLUMNS_IDS.companyEmployeesLocal],
  columns[COLUMNS_IDS.companyEmployeesLocalPercent],
  columns[COLUMNS_IDS.companyEmployeesAbroad],
  columns[COLUMNS_IDS.companyEmployeesAbroadPercent],
  columns[COLUMNS_IDS.companyExecutivesLocal],
  columns[COLUMNS_IDS.companyExecutivesLocalPercent],
  columns[COLUMNS_IDS.nonRnDLocal],
  columns[COLUMNS_IDS.nonRnDLocalPercent],
  columns[COLUMNS_IDS.rndLocal],
  columns[COLUMNS_IDS.rndLocalPercent],
  columns[COLUMNS_IDS.localDepartments],
  columns[COLUMNS_IDS.locations],
  columns[COLUMNS_IDS.dataSources],
  columns[COLUMNS_IDS.companyType],
  columns[COLUMNS_IDS.caseId],
]

export const keysForEmptyColumnsRequest = removeKeywordSuffix(
  companyOverviewColumns.map(el => `${el.key}` || '').filter(key => Boolean(key)),
)
